<div class="main_container">
  <div class="module-header" *ngIf="listWarningDates$ | async as listPendientes">
    <div class="pageName">
      <app-custom-datepicker [warningVal]="listPendientes.length" [dateControl]="date" [dateClass]="dateClass"
        (dateChange)="changeDate($event.value)">
      </app-custom-datepicker>
      <h3 class="pageName__subtitle">Reporte de novedades</h3>
    </div>
    <span class="spacer"></span>
    <ng-container *ngIf="allStudentsData$ | async as allStudents">
      <div class="view-data">
        <app-percentage-single-bar barColor="#6fe667" colorRemaning="blue"
          [percentage]="allStudents.presentesPorcentaje" [label]="'alumnos presentes'" style="width: 100%;">
        </app-percentage-single-bar>
        <mat-chip-set>
          <mat-chip class="small-text" disabled>{{allStudents.presentes}} presentes</mat-chip>
          <mat-chip class="small-text" disabled>{{allStudents.ausentes}} ausentes</mat-chip>
          <mat-chip class="small-text" disabled>{{allStudents.retardos}} retardos</mat-chip>
        </mat-chip-set>
      </div>
    </ng-container>
  </div>
  <div class="table-tools">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filtrar por nombre</mat-label>
      <input matInput placeholder="Filtrar por nombre" (keyup)="filtroTexto($event.target.value)" autocomplete="off">
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filtrar por curso</mat-label>
      <mat-select placeholder="Filtrar por curso" (selectionChange)="filtroCurso($event.value)">
        <mat-option value="{{0}}">Todos</mat-option>
        <ng-container *ngFor="let curso of cursos$ | async">
          <ng-container *ngFor="let cursoDetalle of curso.cursos">
            <mat-option [value]="cursoDetalle.id">{{cursoDetalle.nombre}}</mat-option>
          </ng-container>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filtrar por autorización presencial</mat-label>
      <mat-select [formControl]="presencialForm" placeholder="Filtrar por autorización presencial">
        <mat-option *ngFor="let opcion of presencial" [value]="opcion.value">{{opcion.key}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filtrar por novedad</mat-label>
      <mat-select [formControl]="novedadForm" placeholder="Filtrar por autorización presencial" multiple>
        <mat-option *ngFor="let opcion of tiposAsistencia" [value]="opcion.id">{{opcion.nombre}}</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <button mat-raised-button color="primary" class="row-last-item">
      Generar reporte
    </button> -->
  </div>
  <div class="module-content">
    <div class="full-width mat-elevation-z2" *ngIf="reportedStudents$ | async as data">
      <mat-table #table [dataSource]="data" matSort>
        <ng-container matColumnDef="Curso">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="curso">Curso</mat-header-cell>
          <mat-cell *matCellDef="let element" class="curso">{{element.curso.nickName}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Alumno">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="alumni">Alumno</mat-header-cell>
          <mat-cell *matCellDef="let element" class="alumni ">
            <div class="full-width">
              <div class="full-width">
                <strong>{{element.alumno.apellidosNombres}}
                </strong>
              </div>

              <div class="flex-wrap full-width; align-items: baseline">
                <div class="icon-basic-32px icon-warning" *ngIf="element.isAusenciaConsecutiva">
                  <mat-icon matTooltip="Tres o más ausencias consecutivas" style="cursor:help;">warning
                  </mat-icon>
                </div>
                <app-autorizacion-presencial [alumno]="element.alumno" [autorizaciones]="element.autorizaciones"
                  style="margin: 8px;margin-left: 8px;margin-left: 0;"></app-autorizacion-presencial>
              </div>

            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Acudientes">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="acudientes">Acudientes</mat-header-cell>
          <mat-cell *matCellDef="let element" class="acudientes asistencia-mat-cell">
            <div class="full-width">

              <ul style="margin:0; padding:0;" class="opacity-medium">
                <li *ngFor="let familia of element.familia">
                  <strong style="text-transform:capitalize;">{{familia.nombres}}: </strong><span
                    class="opacity-medium mat-small">
                    {{familia.empresaTelefono}} -
                    {{familia.telefonoMovil}}
                  </span>
                </li>
                <li><strong style="text-transform:capitalize;">{{element.alumno.acudiente}}: </strong>
                  <span class="opacity-medium mat-small">{{element.alumno.acudienteTel}}</span>
                </li>
              </ul>

            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Estado">
          <mat-header-cell *matHeaderCellDef class="asistencia">Asistencia materias</mat-header-cell>
          <mat-cell *matCellDef="let element" class="asistencia asistencia-mat-cell">
            <div class="full-width">
              <ul style="margin:0; padding:0;">
                <li *ngFor="let asistenciaDia of element.asistenciasDia">
                  <button mat-button class="as-mini" *ngIf="(tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('R') > -1
                      || (tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('A') > -1
                      || (tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('PC') > -1"
                    [ngClass]="{'as-retardo': (tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('R') > -1,
                           'as-ausencia': (tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('A') > -1,
                           'as-presentecasa': (tiposAsistencia |filtroID: asistenciaDia.tipoID).codigo.indexOf('PC') > -1}">
                    {{(tiposAsistencia | filtroID: asistenciaDia.tipoID).codigo}}
                  </button>
                  <label><strong>{{asistenciaDia.materia}} </strong><span
                      class="opacity-medium mat-small">{{asistenciaDia.horaCreated}}</span></label>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Permiso">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Permiso</mat-header-cell>
          <mat-cell *matCellDef="let element" style="text-align: center; overflow: visible;">
            <mat-checkbox [checked]="element.asistencia.isPermiso" (change)="setPermiso($event.checked, element)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="General">
          <mat-header-cell *matHeaderCellDef class="general-asis">Novedad general</mat-header-cell>
          <mat-cell *matCellDef="let element" class="general-asis asistencia-mat-cell">
            <button mat-icon-button color="primary" [disableRipple]="true"
              *ngIf="element.asistencia.id === 0; else asistenciaExiste" [matMenuTriggerFor]="menu">
              <mat-icon>add_circle</mat-icon>
            </button>
            <ng-template #asistenciaExiste>
              <div [matMenuTriggerFor]="menu">
                <div class="action">
                  <button mat-button *ngIf="element.asistencia.tipoID !== 12; else permisoSinAsistencia" class="as-mini"
                    [ngClass]="{'as-ausencia': (tiposAsistencia | filtroID: element.asistencia.tipoID).codigo.indexOf('A') > -1,
                                    'as-retardo': (tiposAsistencia | filtroID: element.asistencia.tipoID).codigo.indexOf('R') > -1,
                                    'as-presentecasa': (tiposAsistencia |filtroID: element.asistencia.tipoID).codigo.indexOf('PC') > -1}">
                    {{(tiposAsistencia | filtroID: element.asistencia.tipoID).codigo || '+'}}
                  </button>
                  <div>
                    <button mat-button
                      *ngIf="element.asistencia.isPermiso || element.asistencia.tipoID === 12; else noEsPermiso"
                      class="as-mini">
                      Pe
                    </button>
                    <ng-template #noEsPermiso>
                      <button mat-icon-button color="primary" [disableRipple]="true" class="as-mini"
                        style="background: none!important;">
                        <mat-icon>add_circle</mat-icon>
                      </button>
                    </ng-template>
                  </div>
                  <!-- @Freddy ¿Qué hay que ajustar?  -->
                  <ng-template #permisoSinAsistencia>
                    <button mat-icon-button color="primary" [disableRipple]="true" class="as-mini"
                      style="background: none!important;">
                      <mat-icon>add_circle</mat-icon>
                    </button>
                  </ng-template>
                </div>
              </div>
            </ng-template>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngIf="element.asistencia.id > 0 && element.asistencia.tipoID !== 12"
                (click)="deleteAsistencia(element)">
                Eliminar registro de asistencia
              </button>
              <button mat-menu-item *ngIf="element.asistencia.id > 0 && element.asistencia.isPermiso"
                (click)="setPermiso(false, element)">
                Eliminar registro de permiso
              </button>
              <button *ngIf="element.asistencia.isPermiso === false" mat-menu-item (click)="setPermiso(true, element)">
                Permiso
              </button>
              <button *ngIf="element.asistencia.id !== 13" mat-menu-item (click)="setAsistencia({id: 13}, element)">
                Presente en Casa
              </button>
              <button mat-menu-item [matMenuTriggerFor]="menuAusencia">Ausencia</button>
              <button mat-menu-item [matMenuTriggerFor]="menuRetardos">Retardo</button>
            </mat-menu>

            <mat-menu #menuAusencia="matMenu">
              <ng-container
                *ngFor="let itemAsistencia of tiposAsistencia | tiposAsistencia: ['A', 'A0', 'A1', 'A2', 'A3']">
                <button mat-menu-item (click)="setAsistencia(itemAsistencia, element)">
                  {{itemAsistencia.nombre}}
                </button>
              </ng-container>
            </mat-menu>
            <mat-menu #menuRetardos="matMenu">
              <ng-container
                *ngFor="let itemAsistencia of tiposAsistencia | tiposAsistencia: ['R', 'R0', 'R1', 'R2', 'R3']">
                <button mat-menu-item (click)="setAsistencia(itemAsistencia, element)">
                  {{itemAsistencia.nombre}}
                </button>
              </ng-container>
            </mat-menu>

          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Observacion">
          <mat-header-cell *matHeaderCellDef class="comment-header">Observación</mat-header-cell>
          <mat-cell *matCellDef="let element" class="comment asistencia-mat-cell">
            <div class="full-width">
              <mat-form-field class="full-width" appearance="outline" class="full-width">
                <textarea matInput placeholder="Observación" [(ngModel)]="element.asistencia.comentario"
                  (keyup)="setComentario(element)"></textarea>
              </mat-form-field>
            </div>
            <div class="full-width">
              <mat-form-field *ngIf="element.asistencia.duracion > 0" appearance="standard" class="full-width">
                <mat-label>Novedad vigente</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                  <input matStartDate placeholder="Inicio" [(ngModel)]="element.asistencia.fechaAsistencia" #inputStart>
                  <input matEndDate placeholder="Fin" [(ngModel)]="element.asistencia.fechaAsistenciaFin" #inputEnd>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply
                      (click)="updateFechas(element.asistencia)">Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="asistencia-mat-row"></mat-row>
      </mat-table>
      <div *ngIf="data.length === 0" class="no-records">Sin registros</div>

    </div>
  </div>
</div>

<div>
  <button [matMenuTriggerFor]="addMenu" mat-fab color="primary"
    style="position: fixed; right: 2%; bottom: 2%; z-index: 500" matTooltip="Agregar alumnos">
    <mat-icon>add</mat-icon>
  </button>
  <mat-menu #addMenu="matMenu">
    <button (click)="agregarAlumnos('novedades')" mat-menu-item>Registrar novedad general</button>
    <button (click)="agregarAlumnos('autorizacion')" mat-menu-item>Registrar autorización presencial</button>
  </mat-menu>
</div>
